// extracted by mini-css-extract-plugin
export var editButton = "_p8-0";